import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#050A15] border-t border-white/[0.06] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <img src="/sendpi-icon.png" alt="SendPI" className="h-10 w-auto" />
              <span className="font-space text-3xl font-bold text-white">Send<span className="text-[var(--pi-cyan)]">PI</span></span>
            </Link>
            <p className="text-white/40 text-sm max-w-md mb-6 leading-relaxed">
              The communication intelligence layer for both human and AI. State the outcome, get it &mdash; for people and machines.
            </p>
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.06] text-white/40 text-xs">
                <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                All systems operational
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-white font-space font-bold mb-4 text-sm">Product</h4>
            <ul className="space-y-3">
              <li><Link to="/#features" className="text-white/40 hover:text-white text-sm transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-white/40 hover:text-white text-sm transition-colors">Pricing</Link></li>
              <li><Link to="/#try-now" className="text-white/40 hover:text-white text-sm transition-colors">Try Now</Link></li>
              <li><a href="https://chrome.google.com/webstore" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white text-sm transition-colors">Chrome Extension</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-space font-bold mb-4 text-sm">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/40 hover:text-white text-sm transition-colors">About</Link></li>
              <li><Link to="/privacy" className="text-white/40 hover:text-white text-sm transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/40 hover:text-white text-sm transition-colors">Terms of Service</Link></li>
              <li><Link to="/do-not-sell" className="text-white/40 hover:text-white text-sm transition-colors">Do Not Sell My Info</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/20 text-sm font-space">&copy; 2026 SendPI. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white transition-colors">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white transition-colors">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
